import styled from "styled-components";

export const InquiryListStyled = styled.div`
  background-color: var(--white);
  padding: 15px 10px;
  border-radius: 10px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;

  .inquiry-card-actions {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    gap: 8px;
    width: 100%;
    min-width: 0;
  }

  .inquiry-card-phone {
    flex: 1 1 140px;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;

    span {
      overflow-wrap: anywhere;
      word-break: break-word;
      text-align: start;
    }
  }

  .inquiry-view-btn-wrap {
    flex: 1 1 140px;
    min-width: 0;
    max-width: 100%;
    width: auto !important;

    button {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      height: auto;
      min-height: 40px;
      padding: 10px 12px;
      box-sizing: border-box;

      span {
        text-wrap: wrap;
        white-space: normal;
        text-align: center;
        line-height: 1.2;
      }
    }
  }

  @media (max-width: 420px) {
    .inquiry-card-phone,
    .inquiry-view-btn-wrap {
      flex-basis: 100%;
    }
  }
`;
